import * as React from 'react';
import Button from '@mui/material/Button';
import './UIButton.scss';

export default function UIButton(props) {
    return <Button className="UIButton" disableElevation variant="contained" {...props} />;
}
